/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateOrder400Response,
  CreateOrderRequest,
  GetCart200ResponseInner,
  GetListOfDevices200ResponseInner,
  GetOrders200Response,
} from '../models/index';
import {
    CreateOrder400ResponseFromJSON,
    CreateOrder400ResponseToJSON,
    CreateOrderRequestFromJSON,
    CreateOrderRequestToJSON,
    GetCart200ResponseInnerFromJSON,
    GetCart200ResponseInnerToJSON,
    GetListOfDevices200ResponseInnerFromJSON,
    GetListOfDevices200ResponseInnerToJSON,
    GetOrders200ResponseFromJSON,
    GetOrders200ResponseToJSON,
} from '../models/index';

export interface AddToCartRequest {
    getCart200ResponseInner: GetCart200ResponseInner;
}

export interface CreateOrderOperationRequest {
    createOrderRequest: CreateOrderRequest;
}

export interface RemoveFromCartRequest {
    deviceId: string;
}

/**
 * 
 */
export class HardwareStoreApi extends runtime.BaseAPI {

    /**
     */
    async addToCartRaw(requestParameters: AddToCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['getCart200ResponseInner'] == null) {
            throw new runtime.RequiredError(
                'getCart200ResponseInner',
                'Required parameter "getCart200ResponseInner" was null or undefined when calling addToCart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/hardware-store/cart/items`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetCart200ResponseInnerToJSON(requestParameters['getCart200ResponseInner']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async addToCart(requestParameters: AddToCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addToCartRaw(requestParameters, initOverrides);
    }

    /**
     */
    async clearCartRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/hardware-store/cart`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async clearCart(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.clearCartRaw(initOverrides);
    }

    /**
     */
    async createOrderRaw(requestParameters: CreateOrderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createOrderRequest'] == null) {
            throw new runtime.RequiredError(
                'createOrderRequest',
                'Required parameter "createOrderRequest" was null or undefined when calling createOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/hardware-store/orders`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrderRequestToJSON(requestParameters['createOrderRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createOrder(requestParameters: CreateOrderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createOrderRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getCartRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetCart200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/hardware-store/cart`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCart200ResponseInnerFromJSON));
    }

    /**
     */
    async getCart(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetCart200ResponseInner>> {
        const response = await this.getCartRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getListOfDevicesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetListOfDevices200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/hardware-store/devices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetListOfDevices200ResponseInnerFromJSON));
    }

    /**
     */
    async getListOfDevices(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetListOfDevices200ResponseInner>> {
        const response = await this.getListOfDevicesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getOrdersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrders200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/hardware-store/orders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOrders200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getOrders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrders200Response> {
        const response = await this.getOrdersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async removeFromCartRaw(requestParameters: RemoveFromCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['deviceId'] == null) {
            throw new runtime.RequiredError(
                'deviceId',
                'Required parameter "deviceId" was null or undefined when calling removeFromCart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/hardware-store/cart/items/{deviceId}`.replace(`{${"deviceId"}}`, encodeURIComponent(String(requestParameters['deviceId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async removeFromCart(requestParameters: RemoveFromCartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeFromCartRaw(requestParameters, initOverrides);
    }

}
